module.exports = __webpack_public_path__ + "static/image-affbc485dd07e7f27f5e0260618ec90b.jpg";